export default {
   approvedBy: [],
   form: {},
   formId: '',
   getwayId: '',
   inProgress: true,
   isApproved: false,
   wasCanceled: false,
   isCompleted: false,
   message: '',
   openedAt: '',
   priority: '',
   requestedBy: '',
   requesterName: '',
}